
import themeMixin from '~/mixins/theme'
export default {
  name: 'Button',
  mixins: [themeMixin],
  props: {
    icon: {
      type: String,
      required: true,
    },
    noTheme: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    computedIcon() {
      return this.noTheme
        ? this.icon
        : `${this.icon}-${this.getIconContrastColor(this.theme)}`
    },
  },
}
